var w = jQuery.noConflict(); 
w(document).ready(function () {	
  //w('.selector-wrapper select').addClass('styled');
  //w('select.styled').customSelect(); 
  
  if(w(document).width()<992){
    
    w('#details').hide();
    w('#supplier-backg').hide();
    
    w('a#details-lnk').click(function(){    
      w('#details').slideToggle('slow');
      return false;
    });
    w('a#supplier-lnk').click(function(){    
      w('#supplier-backg').slideToggle('slow');
      return false;
    });
    
  }
  else
  {
    w('a#details-lnk').click(function(){    
      return false;
    });
    w('a#supplier-lnk').click(function(){    
      return false;
    });
  }
  
  //var froptn = $('select#product-select option:first-child').text();		                                      
  //var arr = froptn.split('-');
  //jQuery('#price-preview').text($.trim(arr[1]));
  
   w('#product-select-option-0 option').each(function() {
     var curropt = w(this);
     var opt = w(this).text();
     w('#product-select option').each(function() {
       var optwthprice = w(this).text();
       var arr = optwthprice.split(' - ');
       if(w.trim(arr[0])==opt){
         w(curropt).text(opt+' - '+w.trim(arr[1]));
       }
     });
   });
  
});


w( ".list-wrapper ul li .product-box" ).mouseout(function() {
	w(".overlayy",this).stop().animate({top:-100+'%'},220);
})
.mouseover(function() {
	w(".overlayy",this).stop().animate({top:0},220);
});











